import { schema } from 'normalizr'

export const occupation = new schema.Entity('occupations')
occupation.schema = { children: [occupation] }

export const entertainer = new schema.Entity('entertainers')
export const eventTicket = new schema.Entity('eventTickets', {}, { idAttribute: 'eventId' })
